import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RungisSupplierComponent } from './components/supplier-form/rungis-supplier.component';

const routes: Routes = [
    {
        path: ':id',
        component: RungisSupplierComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class RungisSupplierRoutingModule {
}
